import React from 'react';
import { Icon } from "../ecosystem";

const FindCareFormWrapper = ({
    children,
    formOpen,
    toggleForm,
    variant = 'primary'
}) => {

    return (variant === 'primary'
        ? <div className="col-12 find-care-form-container" >
            <div className="row find-care-form find-care-form--primary">
                <div className={"col-12 " + (formOpen ? " form-open" : "")}> {/* Toggle class name of form-open */}
                    <div className="row find-care-form__modify-btn">
                        <div className="col-12 form-group">
                            <a className="btn btn-primary"
                                onClick={toggleForm}>MODIFY SEARCH</a> {/* Wire button to open form */}
                            <div className="search-form-close-btn"
                                onClick={toggleForm}>
                                <Icon name="x" color="$color-secondary-a2" />
                            </div> {/* Wire button to close form */}
                        </div>
                    </div>
                    <div className="row find-care-form__fields">
                        {children}
                    </div>
                </div>
            </div>
        </div>
        : <div className={`row find-care-form--${variant}`}>
            {children}
        </div>
    );
}

export default FindCareFormWrapper;
